import { BoxHooksContextProvider } from '@decent.xyz/box-hooks';

interface DecentProviderProps {
  children: React.ReactNode;
}

/**
 * DecentProvider component that provides the Decent context to its children.
 * @component
 * @param {DecentProviderProps} props - The properties for the component.
 * @param {React.ReactNode} props.children - The child components to be wrapped by the Decent context.
 * @returns {JSX.Element} The DecentProvider component.
 */
export const DecentProvider: React.FC<DecentProviderProps> = ({
  children,
}: DecentProviderProps) => {
  return (
    <BoxHooksContextProvider
      apiKey={process.env.NEXT_PUBLIC_DECENT_API_KEY || ''}
    >
      {children}
    </BoxHooksContextProvider>
  );
};
